export const ValidaEmail = (email) => {
  if (!email) return "Digite seu email";
  else if (
    !email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
  )
    return "Email inválido";
  else return "";
};

export const ValidaSenha = (senha) => {
  if (!senha) return "Digite sua senha";
  else if (senha.length < 6) return "Deve conter pelo menos 6 caracteres";
  else return "";
};

export const ValidaSenha2 = (senha, senha2) => {
  if (!senha2) return "Digite sua senha";
  else if (senha !== senha2) return "As senhas não são iguais";
  else return "";
};

export const ValidaLogin = (erro) => {
  let r = {};

  if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/user-not-found") r.email = "Email não cadastrado";

  if (erro === "auth/internal-error") r.senha = "Senha inválida";
  else if (erro === "auth/wrong-password") r.senha = "Senha incorreta";
  else if (erro === "auth/too-many-requests")
    r.senha =
      "Conta bloqueada temporariamente. Tente novamente mais tarde ou redefina sua senha.";

  return r;
};

export const ValidaCadastro = (erro) => {
  let r = {};
  if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/email-already-in-use")
    r.email = "Email já cadastrado";

  if (erro === "auth/internal-error") r.senha = "Senha inválida";
  else if (erro === "auth/weak-password") r.senha = "Mínimo de 6 caracteres";

  return r;
};

export const ValidaRedefinir = (erro) => {
  let r = {};

  if (erro === "auth/missing-email") r.email = "Digite seu email";
  else if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/user-not-found") r.email = "Email não cadastrado";

  return r;
};

const validaCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, "");

  if (cpf.length !== 11) return false;

  // Elimina CPFs inválidos conhecidos
  if (/^(\d)\1+$/.test(cpf)) return false;

  let soma = 0;
  let resto;

  // Primeiro dígito verificador
  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;

  // Segundo dígito verificador
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};

const validaRG = (valor) => {
  const limpo = valor.replace(/\s/g, "");

  // RG antigo (1 a 9 dígitos + dígito verificador opcional)
  const rgRegex = /^[0-9]{1,9}[0-9Xx]?$/;

  // RG formatado (00.000.000-0 ou 0.000.000-X)
  const rgFormatadoRegex = /^[0-9]{1,2}\.?[0-9]{3}\.?[0-9]{3}-?[0-9Xx]?$/;

  // RG Nacional (CPF)
  const cpfRegex = /^[0-9]{11}$/;

  return (
    rgRegex.test(limpo.replace(/\D/g, "")) ||
    rgFormatadoRegex.test(limpo) ||
    cpfRegex.test(limpo.replace(/\D/g, ""))
  );
};

const validaTelefone = (telefone) => {
  telefone = telefone.replace(/\D/g, "");

  // Com DDD
  if (telefone.length === 11) {
    // Celular
    return /^([1-9]{2})9[0-9]{8}$/.test(telefone);
  }

  if (telefone.length === 10) {
    // Fixo
    return /^([1-9]{2})[2-5][0-9]{7}$/.test(telefone);
  }

  return false;
};

const validaCEP = (cep) => {
  cep = cep.replace(/\D/g, "");

  if (cep.length !== 8) return false;

  // Evita CEPs inválidos como 00000000
  if (/^(\d)\1+$/.test(cep)) return false;

  return true;
};

export const ValidaForm1 = (form) => {
  let erro = {};

  //NOME
  if (!form?.nome) erro.nome = "Campo obrigatório";
  else if (form?.nome.length < 3) erro.nome = "Nome inválido";

  //VINCULO
  if (!form?.vinculo) erro.vinculo = "Escolha uma opção";

  //CPF
  if (!form?.cpf) erro.cpf = "Campo obrigatório";
  else if (!validaCPF(form?.cpf)) erro.cpf = "CPF inválido";

  //RG
  if (!form?.rg) erro.rg = "Campo obrigatório";
  else if (!validaRG(form?.rg)) erro.rg = "RG inválido";

  //FONE 1
  if (!form?.fone1) erro.fone1 = "Campo obrigatório";
  else if (!validaTelefone(form?.fone1)) erro.fone1 = "Telefone inválido";

  //FONE 2
  if (!form?.fone2) {
  } else if (!validaTelefone(form?.fone2)) erro.fone2 = "Telefone inválido";

  //LOGRADOURO
  if (!form?.logradouro1) erro.logradouro1 = "Escolha uma opção";

  //ENDEREÇO
  if (!form?.endereco1) erro.endereco1 = "Campo obrigatório";

  //NUMERO
  if (!form?.numero1) erro.numero1 = "Campo obrigatório";

  //BAIRRO
  if (!form?.bairro1) erro.bairro1 = "Campo obrigatório";

  //CIDADE
  if (!form?.cidade1) erro.cidade1 = "Campo obrigatório";

  //CEP
  if (!form?.cep1) erro.cep1 = "Campo obrigatório";
  else if (!validaCEP(form?.cep1)) erro.cep1 = "CEP inválido";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaForm2 = (form) => {
  let erro = {};

  //LOGRADOURO
  if (!form?.logradouro2) erro.logradouro2 = "Escolha uma opção";

  //ENDEREÇO
  if (!form?.endereco2) erro.endereco2 = "Campo obrigatório";

  //NUMERO
  if (!form?.numero2) erro.numero2 = "Campo obrigatório";

  //BAIRRO
  if (!form?.bairro2) erro.bairro2 = "Campo obrigatório";

  //CIDADE
  if (!form?.cidade2) erro.cidade2 = "Campo obrigatório";

  //CEP
  if (!form?.cep2) erro.cep2 = "Campo obrigatório";
  else if (!validaCEP(form?.cep2)) erro.cep2 = "CEP inválido";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaForm3 = (form) => {
  let erro = {};

  //LOGRADOURO
  if (!form?.logradouro3) erro.logradouro3 = "Escolha uma opção";

  //ENDEREÇO
  if (!form?.endereco3) erro.endereco3 = "Campo obrigatório";

  //NUMERO
  if (!form?.numero3) erro.numero3 = "Campo obrigatório";

  //BAIRRO
  if (!form?.bairro3) erro.bairro3 = "Campo obrigatório";

  //CIDADE
  if (!form?.cidade3) erro.cidade3 = "Campo obrigatório";

  //CEP
  if (!form?.cep3) erro.cep3 = "Campo obrigatório";
  else if (!validaCEP(form?.cep3)) erro.cep3 = "CEP inválido";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaForm5 = (form) => {
  let erro = {};

  if (!form?.nomeResponsavel) erro.nomeResponsavel = "Preencha este campo";
  else if (form?.nomeResponsavel.length < 3)
    erro.nomeResponsavel = "Nome inválido";

  //CPF
  if (!form?.cpfResponsavel) erro.cpfResponsavel = "Campo obrigatório";
  else if (!validaCPF(form?.cpfResponsavel))
    erro.cpfResponsavel = "CPF inválido";

  //RG
  if (!form?.rgResponsavel) erro.rgResponsavel = "Campo obrigatório";
  else if (!validaRG(form?.rgResponsavel)) erro.rgResponsavel = "RG inválido";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaForm6 = (form) => {
  let erro = {};

  if (!form?.urlRg) erro.rg = "Envio obrigatório";

  if (!form?.urlVinculo) erro.vinculo = "Envio obrigatório";

  if (!form?.urlResidencia) erro.residencia = "Envio obrigatório";

  if (!form?.urlFoto) erro.foto = "Envio obrigatório";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaForm7 = (form) => {
  let erro = {};

  if (!form?.dataInicio) erro.dataInicio = "Informação obrigatória";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};
